/* eslint-disable @next/next/no-img-element */
import styles from '@buddieshr/styles/stany/Home.module.scss';
import MetaHeader from '@buddieshr/components/metaHeader';
import { useRouter } from 'next/router';
import Header from '@buddieshr/components/header';
import Footer from '@buddieshr/components/footer';
import TextColored from '@buddieshr/components/text/textColored';
import AddToSlackButton from '@buddieshr/components/addToSlackButton';
import PageWrapper from '@buddieshr/components/templates/pageWrapper';
import { Tag } from 'antd';
import Features from '@buddieshr/components/app/features';
import Benefits from '@buddieshr/components/benefits';
import InstallNow from '@buddieshr/components/installNow';
import GetStarted from '@buddieshr/components/app/getStarted';
import Rated from '@buddieshr/components/rated';
import G2Logos from '@buddieshr/components/g2Logos';
import TrustedBy from '@buddieshr/components/trustedBy';
import { PRODUCTS } from '@buddieshr/utils/constants-products';
import PricingButtonHint from '@buddieshr/components/pricing/pricingbuttonHint';
import BuddieshrAppList from '@buddieshr/components/buddieshrAppList';
import LogoApp from '@buddieshr/components/app/logoApp';
import Image from 'next/image';

export default function Home() {
  const router = useRouter();

  const app = PRODUCTS.find((c) => c.id === 'Ticky');
  return (
    <>
      <MetaHeader
        title={'Slack Time-tracking Bot | #1 Slack App - Ticky'}
        description={
          'Make sure employees declare their time by sending reminders directly in Slack. Track project costs and automate time tracking.'
        }
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/ticky`}
        currentShare={`https://buddieshr.com/img/apps/${app.slug}/share_preview_ticky.png`}
        locale={router.locale}
        pageSlug={app.slug}
      />
      <Header app={app} />
      <main className={styles.main} style={{ background: app.backgroundColor }}>
        <PageWrapper width={1500}>
          <div className={styles.firstSectionWrapper}>
            <LogoApp
              app={app}
              removeBack
              withText
              withSubtitle
              removeByBuddies
              wrapperStyle={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 36,
                maxWidth: '100%',
              }}
              style={{
                textAlign: 'left',
                margin: 'auto',
                border: '2px solid #0000000a',
                borderRadius: '10px',
                padding: '6px 12px',
                paddingBottom: '8px',
                transform: 'scale(1.2)',
                maxWidth: 'calc(100% - 40px)',
              }}
            />
            <div className={styles.tagWrapper}>
              <Tag color={app.tagColor} className={styles.tag}>
                TIME TRACKING
              </Tag>
            </div>
            <h1 className={styles.mainTitle}>
              <TextColored app={app}>Track time</TextColored> and{' '}
              <TextColored app={app}>project costs</TextColored> effortlessly
            </h1>
            <div className={styles.subtitle}>
              {
                'Automate time tracking in Slack with reminders to make sure your team declares their working hours. Easily visualize project costs and profitability.'
              }
            </div>
            <div className={styles.ratedWrapper}>
              <Rated />
            </div>
            <div className={styles.actions}>
              <AddToSlackButton app={app} />
              <PricingButtonHint />
            </div>
          </div>
        </PageWrapper>
        <TrustedBy hideInstall withoutBackground />
        <br />
        <br />
        <br />
        <PageWrapper>
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ marginBottom: 24 }}>
              <TextColored>
                {"Time-tracking doesn't have to be boring"}
              </TextColored>
            </h2>
            <div>
              <Image
                style={{
                  height: 'auto',
                  maxWidth: '100%',
                }}
                src="/img/apps/ticky/ticky_screen1.png"
                alt="track time spent per project in slack"
                width={757}
                height={720}
              />
              <Image
                style={{
                  height: 'auto',
                  maxWidth: '100%',
                }}
                src="/img/apps/ticky/ticky_screen2.png"
                alt="track time spent per project in slack"
                width={757}
                height={720}
              />
            </div>
          </div>
          <div className={styles.benefitsWrapper}>
            <Benefits app={app} />
          </div>
          <div style={{ textAlign: 'center' }}>
            <Image
              style={{
                height: 'auto',
                maxWidth: '100%',
              }}
              src="/img/apps/ticky/screens.png"
              alt="track time spent per project in slack"
              width={757}
              height={720}
            />
          </div>

          <G2Logos />
          <div className={styles.featureWrapper} id="features">
            <Features app={app} />
          </div>
          <GetStarted app={app} />
          <div className={styles.installWrapper}>
            <InstallNow
              app={app}
              gradient={app.gradient}
              title="Ready to automate time tracking?"
              subtitle="Install now and streamline remote work in Slack."
            />
          </div>
        </PageWrapper>
        <div>
          <BuddieshrAppList appToHide={app.slug} />
        </div>
      </main>
      <Footer app={app} />
    </>
  );
}
